import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  VideoCameraOutlined,
  TeamOutlined,
  SendOutlined,
  BarChartOutlined,
  SettingOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import './MainLayout.less';

const { Header, Sider, Content } = Layout;

const menuItems = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined />,
    label: '工作台'
  },
  {
    key: '/content',
    icon: <FileTextOutlined />,
    label: '内容创作'
  },
  {
    key: '/video',
    icon: <VideoCameraOutlined />,
    label: '视频混剪'
  },
  {
    key: '/account',
    icon: <TeamOutlined />,
    label: '账号管理'
  },
  {
    key: '/publish',
    icon: <SendOutlined />,
    label: '发布管理'
  },
  {
    key: '/stats',
    icon: <BarChartOutlined />,
    label: '数据统计'
  },
  {
    key: '/settings',
    icon: <SettingOutlined />,
    label: '系统设置'
  }
];

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <Layout className="main-layout">
      <Sider trigger={null} collapsible collapsed={collapsed} theme="dark">
        <div className="logo">
          {collapsed ? '抖音矩阵' : '抖音矩阵账号管理系统'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header className="header">
          <div className="header-left">
            <span
              className="trigger"
              onClick={() => setCollapsed(!collapsed)}
            />
          </div>
          <div className="header-right">
            <span className="user-info">
              {localStorage.getItem('username') || '管理员'}
            </span>
            <LogoutOutlined className="logout-icon" onClick={handleLogout} />
          </div>
        </Header>
        <Content className="content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
